export default "__VITE_ASSET__BQ$1vulW__"